import { useLocation } from 'react-router'
import unitaskLogo from '../assets/img/unitask-logo.png'

export default function Footer() {

  const location = useLocation()
  if (location.pathname.includes('howto')) return <></>
  return (
    <div className="footer">
      <a href="https://en.unitask-inc.com" className="logo" target="_blank" rel="noopener noreferrer">
        <img width={200} src={unitaskLogo} alt="logo" />
      </a>
    </div>
  )
}
